import { axios } from 'shared/services/axios'

export const attendActivity = ({ boardId, attendanceGuid, activityType }) => {
  return axios.post(`${FollozeState.envConfig.ANALYTICS_SERVICE_ADDRESS}/live_board/v1/boards/${boardId}/attend_activities`,
    {
      board_id: boardId,
      guid: attendanceGuid,
      activity_type: activityType
    }
  )
}

export const updateAttendActivity = ({ boardId, attendanceGuid, activityType }) => {
  return axios.put(`${FollozeState.envConfig.ANALYTICS_SERVICE_ADDRESS}/live_board/v1/boards/${boardId}/attend_activities`,
    {
      board_id: boardId,
      guid: attendanceGuid,
      activity_type: activityType
    }
  )
}
